import React from "react";
import { WrappedLink } from "@components/navigation";
import HeaderItemWrapper from "./HeaderItemWrapper";

export default function HeaderRegistrationButton({
	culture,
	text,
}: {
	culture: string;
	text: string;
}) {
	return (
		<HeaderItemWrapper>
			<WrappedLink
				to={`/${culture}/auth/register`}
				className="header__btn header__btn--registration btn btn--sml btn--nero"
			>
				{text}
			</WrappedLink>
		</HeaderItemWrapper>
	);
}
